    
(function(document){

	const handlerFiltersTest = (target) => {
		const productFacet = target.querySelector('.product-facet');
		const buttonFilters = target.querySelectorAll('.product-facet__main button.product-facet__meta-bar-item');
		const filterTest = target.querySelector('#filter-test');

		if (buttonFilters) {
			buttonFilters.forEach((button) => {
				button.style.display = 'none';
			});
		}

		if (filterTest) {
			filterTest.style.display = 'block';
			productFacet.classList.add('filter--actived');
		}

	};

	const currentPage = window.location.pathname;
	const urlParms = window.location.search;
	
	const targetCollection = '/collections/all';
	const testABQueryParm = 'produtos';
	
	if ((currentPage === targetCollection) && (urlParms.indexOf(testABQueryParm) > -1)) {
	
		document.addEventListener('DOMContentLoaded', function(){
			handlerFiltersTest(document);
		});

		document.addEventListener('facet:criteria-changed', function(event){
			const filter = event.target || document;
			const newDocument = filter.closest('.container');
			handlerFiltersTest(newDocument);
		});
	}
	
})(document);